import recommended_jobs_widget_0 from "file:///home/wldocker/wl-cms/sites/modules/recommended-jobs-widget/ui/src/recommended-jobs-widget.js";



import recommended_jobs_widget_0Stylesheet from "file:///home/wldocker/wl-cms/sites/modules/recommended-jobs-widget/ui/src/recommended-jobs-widget.scss";recommended_jobs_widget_0();